import React, {useState, useEffect}  from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import axios from 'axios';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


/**
 * Function to present the details of pricing plans
 * @param {*} props
 * @returns
 */
function SubjectTeacherForm(props) {
  const {
    subjects
  } = props;
  
  const [subject, setSubject] = useState([]);
  const endpoint = 'http://127.0.0.1:8000/api/subject/deleteTeacher/';

  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const handleCloseError = (event, reason) => {
    setOpen(false);
  };

  const handleClose = (event, reason) => {
    setOpenError(false);
  };
  
  /**
 * Method to delete the register in the table
 * @param {data} data
 */
  const handleDelete = (index) => {
    const newSubject = [...subject];
    newSubject.splice(index, 1);
    setSubject(newSubject);
  };

  /**
   * Method to close the dialog and show the success message
   * @param {data} data
   */
  const handleOK = (data) => {
    for (let cont = 0; cont < subject.length; cont += 1) {
      if (subject[cont].id === data.id) {
        handleDelete(cont);
        break;
      }
    }
    setOpen(true);
  };

   /**
   * Method to delete the register and create que request
   * @param {*} formData
   */
   const onDelete = async(event) => {
    const id = event.target.value;
    await axios.post(endpoint+id).then((response) => {
      handleOK(response.data);
    })
    .catch((e) => {
      handleError(e);
    });
  };

  const handleError = () => {
    setErrorMessage('La acción no se pudo realizar.');      
    setOpenError(true);
  };

  /**
 * Method to set the documents list and tabe columns
 */
  useEffect(() => {
    setSubject(subjects);
  }, []);

  return (
    <form id="teacherForm">
      <Grid container spacing={3}>
        <Grid item xs={12}>

          <Table>

            <TableHead>
              <TableRow style={{backgroundColor: "#68dcb9", color: "#FFFFFF"}}>
                <TableCell align="center">Año Lectivo</TableCell>
                <TableCell align="center">Curso</TableCell>
                <TableCell align="center">Materia</TableCell>
                <TableCell align="center">Acción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subject.map((value, key) => (
                <TableRow >
                  <TableCell align="center"> {value.year}</TableCell>
                  <TableCell align="center">{value.course}</TableCell>
                  <TableCell align="center">{value.name}</TableCell>
                  <TableCell align="center"><Button style={{color: "#68dcb9", borderColor: "#68dcb9", border:"double" }} startIcon={<DeleteIcon/>} onClick={onDelete} value={value.id}>Eliminar</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose} >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="success" sx={{ width: '100%' }} center>
          La acción se ejecutó de manera correcta.
        </Alert>
      </Snackbar>
        </Grid>


      </Grid>
    </form>
  );
}

SubjectTeacherForm.propTypes = {
  subjects: PropTypes.array.isRequired
};

export default SubjectTeacherForm;
